import { db } from '@/main'
import { doc, updateDoc } from "firebase/firestore";

export default {
  name: 'theme-toggle',
  components: {},
  props: [],
  data () {
    return {
      theme: localStorage.getItem("theme")
    }
  },
  computed: {
    user () {
      return this.$store.getters.userData
    }
  },
  mounted () {
    console.log("themetoggle mounted")
    
  },
  methods: {
    async toggleTheme () {
      console.log('toggling theme, currently', this.user.adminConfig.theme)
      if (this.user.adminConfig.theme == "dark") {
        this.user.adminConfig.theme = "light";
        document.body.setAttribute("data-theme", "light");
      } else {
        this.user.adminConfig.theme = "dark";
        document.body.setAttribute("data-theme", "dark");
      }

      try {
        await updateDoc(doc(db, "users", this.user.id),{
          'adminConfig': this.user.adminConfig
        })
        console.log("user admin config saved")
        this.$toast.success("Settings Saved")
      } catch (error) {
        console.log("error saving user config:", error)
        this.$toast.error(`Error: ${error}`)
      }
      console.log(`theme is now ${this.theme}`)
    }
  }
}


